import React from 'react'

const Reporttable = ({list}) => {
//  console.log(list)
    return (
      <div className="container-fluid">
        <table className="table responsive table-hover">
          <thead >
            <tr>
              <th scope="col">ลำดับ</th>
              <th scope="col">ไม้ท่อนรับเข้า</th>
              <th scope="col">ลูกค้า หน้าโรงงาน</th>
              <th scope="col">ลานลูกค้า</th>
              <th scope="col">เหมาแปลง แบบไร่</th>
              <th scope="col">เหมาแปลง แบบตัน</th>
              <th scope="col">ไม้สาขาตาชั่ง HUB</th>
              <th scope="col">ไม้สาขา หางลาก น้ำหนัก</th>
              <th scope="col">ไม้ท่อน ออป.</th>
              <th scope="col">ไม้ท่อน SMT</th>
              <th scope="col">ไม้เก็บกลับ</th>
              <th scope="col">รถเข้าโรงงาน(คัน)</th>
              <th scope="col">รอเกิน 2 ชม.(คัน)</th>
              <th scope="col">เฉลี่ย (ชม./คัน)</th>
            </tr>
          </thead>


          <tbody>
              { list && list.length > 1 &&  list.map((item, index) => (
            
              <tr key = {item.id}>
              <th scope="row"   >



                { item.id == "999" ? null:
                <span className="badge rounded-pill bg-secondary me-1">{item.id}</span> 
                }


               { item.id == "999" ? "Total":
               <span className="">{item.BranchName}</span>
                }

            
              </th>

              <td>
                { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}} >{item.weighttotal}   </span> :
                 item.weighttotal > 0 ? 
                 <span className="badge bg-success ms-1" style={{ fontSize: "14px"}} >{item.weighttotal}    </span> : 
                 null

                }
              
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}} >{item.ลูกค้าไม้หน้าโรงงาน} </span> :
                 item.ลูกค้าไม้หน้าโรงงาน > 0 ?    <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}}  >{item.ลูกค้าไม้หน้าโรงงาน}</span>
               : 
               null
               }
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้ลานลูกค้า}</span> :
                 item.ไม้ลานลูกค้า > 0 ?  
               <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}} >{item.ไม้ลานลูกค้า}</span> :
               null
              }
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้เหมาแปลงแบบไร่}</span> :
                 item.ไม้เหมาแปลงแบบไร่ > 0 ?
               <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้เหมาแปลงแบบไร่}</span>
              :   null
              }
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้เหมาแปลงแบบตัน}</span> :
                 item.ไม้เหมาแปลงแบบตัน > 0 ?
               <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้เหมาแปลงแบบตัน}</span> :
               null
              }
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้สาขาตาชั่งHUB}</span> :
                 item.ไม้สาขาตาชั่งHUB > 0 ?
               <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้สาขาตาชั่งHUB}</span> :
               null
              }
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้สาขาหางลากน้ำหนัก}</span> :
                 item.ไม้สาขาหางลากน้ำหนัก > 0 ?
               <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้สาขาหางลากน้ำหนัก}</span> :
               null
               }
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}} >{item.ไม้เหมาแปลงออป}</span> :
                 item.ไม้เหมาแปลงออป > 0 ?
               <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้เหมาแปลงออป}</span> :
               null
               }
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1" style={{ fontSize: "14px"}}  >{item.ไม้สมาชิกSMT}</span> :
                 item.ไม้สมาชิกSMT > 0 ?
               <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้สมาชิกSMT}</span> :
               null
               
               }
               
              </td>
             <td>
             { item.id == "999"  ?
                 <span className="badge bg-warning ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้เก็บกลับKN}</span> :
                 item.ไม้เก็บกลับKN > 0 ?
               <span className="badge bg-success ms-1"  style={{ fontSize: "14px"}}  >{item.ไม้เก็บกลับKN}</span>:
               null
              }
               
              </td>
              <td>
                <span className="badge bg-warning me-1"  style={{ fontSize: "14px"}}  >{item.around}</span>
              
              </td>
              <td>

                { item.overtime > 0 ? <span className="badge bg-danger me-1"  style={{ fontSize: "14px"}}  >{item.overtime}</span> :null}
              
              </td>
              <td>
                <span className="badge bg-warning me-1"  style={{ fontSize: "14px"}}  >{item.avg}</span>
              
              </td>
              </tr>
              
             
              ))



            }
         
      

            {/* <tr>
              <th scope="row">

                <span className="badge rounded-pill bg-secondary me-1">1</span>
                <span className="">โรงชิพปักธงชัย</span>
              </th>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
             <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
                <span className="badge bg-primary me-1">0</span>
              
              </td>
              <td>
                <span className="badge bg-danger me-1">0</span>
              
              </td>
              <td>
                <span className="badge bg-primary me-1">0</span>
              
              </td>
            </tr>
            <tr>
              <th scope="row">
                <span className="badge rounded-pill bg-secondary me-1">2</span>
                <span className="">โรงชิพปักธงชัย</span>
              </th>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
               <span className="badge bg-success ms-1">50</span>
              </td>
              <td>
                <span className="badge bg-primary me-1">0</span>
              
              </td>
              <td>
                <span className="badge bg-danger me-1">0</span>
              
              </td>
              <td>
                <span className="badge bg-primary me-1">0</span>
              
              </td>
            </tr>
            <tr>
        
              <th scope="row">
                <span className="badge rounded-pill bg-secondary me-1">3</span>
                <span className="">โรงชิพปักธงชัย</span>
              </th>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
               <span className="badge badge-secondary ms-1">50</span>
               
              </td>
              <td>
                <span className="badge bg-primary me-1">0</span>
              
              </td>
              <td>
                <span className="badge bg-danger me-1">0</span>
              
              </td>
              <td>
                <span className="badge bg-primary me-1">0</span>
              
              </td>
            </tr>
            <tr>
            
              <th scope="row">     
                <span className="">รวม</span>
              </th>
              <td>
              <span className="badge bg-success ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-success ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-success ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-success ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-success ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-success ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-success ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-warning ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-warning ms-1">300</span>
              </td>
             <td>
              <span className="badge bg-warning ms-1">300</span>
              </td>
              <td>
                <span className="badge bg-warning me-1">0</span>
              
              </td>
              <td>
                <span className="badge bg-danger me-1">0</span>
              
              </td>
              <td>
                <span className="badge bg-warning me-1">0</span>
              
              </td>
            </tr>
             */}
            
       

          </tbody>
        </table>
      </div>
    );
}
 
export default Reporttable;